
Monet.Form = Monet.Form || {};
Monet.Form.Modal = Monet.Form.Modal || {};

Monet.Form.Modal.Confirm = function ({ questionText, selector, sizeOptions } ) {

    this.setButtonsCallback = callbacks =>  this.buttonsCallback = callbacks ;

    this.modalCallbacks = {
        onAfterShowModalForm: () => {

            const container = document.querySelector(`${selector} .popupFormContainer`);
            container.className += ' confirm';
            if (container !== null) {
                container.appendChild(this.createAllStructure());

            }
        }
    };

    this.createAllStructure = () => {

        const container = document.createElement('div');
        container.className  = 'confirmContainer';

        const titleContainer = document.createElement('div');
        titleContainer.className  = 'title';

        const image = document.createElement('div');
        image.className = 'fa fa-exclamation-triangle';

        const label = document.createElement('label');
        label.innerHTML = Monet.I18n.getResourcesByKey("default.atention");

        const question = document.createElement('div');
        question.className = "question";
        question.innerHTML = Monet.I18n.getResourcesByKey(questionText);

        titleContainer.appendChild(image);
        titleContainer.appendChild(label);

        container.appendChild(titleContainer);
        container.appendChild(question);
        container.appendChild(this.renderButtons());

        return container;
    };

    this.renderButtons = () => {

        const okButton = new Monet.UI.Fields.Render({
            label: Monet.I18n.getResourcesByKey('option.yes')
            ,type: 'BUTTON'
            ,name: "confirmButton"
            ,customJavaScript: this.buttonsCallback.confirm
        }, 'confirmButton').render().rootEl;

        const cancelButton = new Monet.UI.Fields.Render({
            label: Monet.I18n.getResourcesByKey('option.no')
            ,type: 'BUTTON'
            ,name: "cancelButton"
            ,customJavaScript: this.buttonsCallback.cancel
        }, 'cancelButton').render().rootEl;

        const buttonContainer = document.createElement('div');
        buttonContainer.className  = 'buttonContainer standard-form-buttons';
        buttonContainer.appendChild(cancelButton);
        buttonContainer.appendChild(okButton);

        return buttonContainer;
    };

    this.createModal = () => {

        this.modalForm = new Monet.Form.Modal(selector, sizeOptions || {
            width: 400,
            height: 200
        }, this.modalCallbacks);
    };

    this.showModalForm = function () {

        this.modalForm.showModalForm();

    };

    this.createModal();

};
